import { Dictionary } from 'lodash';

import { TFunction } from '@lyearn/i18n';
import { QuizPlayerPerformanceType } from '@/modules/corporate/modules/quiz/views/QuizPlayer/interfaces';
import { QuizContentType } from '@/types/schema';

import { QuizDetailsContentFragment } from '../../graphql/fragments/generated/QuizDetailsContent';
import { QuizDetailsPerformanceFragment } from '../../graphql/fragments/generated/QuizDetailsPerformance';

export interface QuizDetailsActionProps {
  isEmbed?: boolean;
  content: QuizDetailsContentFragment;
  quizPerformance?: QuizDetailsPerformanceFragment;
  responsive?: boolean;
  parentEntityId: string;
  learnerId: string;
}

export interface RenderAttemptHistoryProps {
  t: TFunction;
  content: QuizDetailsContentFragment;
  showAttemptHistory: boolean;
  toggleAttemptHistory: () => void;
  onClickAttemptHistory: (id: string) => void;
  onRetakeQuiz?: () => void;
  disabled?: boolean;
  responsive?: boolean;
}

export interface RenderStartQuizProps {
  t: TFunction;
  content: QuizDetailsContentFragment;
  onStartQuiz: () => void;
  responsive?: boolean;
}

export interface QuizReviewProps {
  content: QuizContentType;
  performancesByEntityId: Dictionary<QuizPlayerPerformanceType>;
  open: boolean;
  toggle: () => void;
}

export enum QuizDetailsActions {
  StartQuiz = 'START_QUIZ',
  ResumeQuiz = 'RESUME_QUIZ',
  ReattemptQuiz = 'REATTEMPT_QUIZ',
  ViewResults = 'VIEW_RESULTS',
  AttemptsHistory = 'ATTEMPTS_HISTORY',
}
